/* prettier-ignore-file */
import React from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";

const EmailPreview = ({ 
  templateType = "delivery",
  mainTitle = "",
  headerSubtitle = "",
  greetingText = "",
  customInstructions = "",
  buttonText = "",
  footerMessage = "",
  stripeRefundReceiptLink = "",
  refundAmount = "",
  stripeReceiptLink = "",
  paymentAmount = "",
  storeName = "Bonita Bikes",
  storeLogo = "",
}) => {
  
  // Sample data for preview
  const sampleData = {
    customerName: "John Smith",
    bookingId: "BK-123456",
    securityPin: "417",
    startDate: "Dec 15, 2025",
    endDate: "Dec 18, 2025",
    days: "3",
    bicyclesAndAddOns: "Mountain Bike × 2\nHelmet × 2\nBike Lock × 1",
    subtotal: "180.00",
    tax: "13.50",
    totalCost: "193.50",
    storePhone: "(555) 123-4567",
    storeEmail: "info@bonitabikes.com",
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.emailContainer}>
        {/* Header */}
        <View style={styles.header}>
          {storeLogo && (
            <View style={styles.logoContainer}>
              <Text style={styles.logoPlaceholder}>📷 Logo</Text>
            </View>
          )}
          <Text style={styles.headerTitle}>
            {mainTitle || "🚴 Booking Confirmed!"}
          </Text>
          <Text style={styles.headerSubtitle}>
            {headerSubtitle || "Get ready for your adventure with " + storeName}
          </Text>
        </View>

        {/* Greeting */}
        <View style={styles.section}>
          <Text style={styles.greeting}>Hi <Text style={styles.bold}>{sampleData.customerName}</Text>,</Text>
          <Text style={styles.greetingText}>
            {greetingText || "Great news! Your bike rental has been confirmed and payment received. We can't wait to get you out on the trails! 🎉"}
          </Text>
        </View>

        {/* Booking Details */}
        <View style={styles.detailsBox}>
          <Text style={styles.detailsTitle}>📋 Booking Details</Text>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>🆔 Booking ID:</Text>
            <Text style={styles.detailValue}>{sampleData.bookingId}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>📅 Start Date:</Text>
            <Text style={styles.detailValue}>{sampleData.startDate}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>📅 End Date:</Text>
            <Text style={styles.detailValue}>{sampleData.endDate}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>⏱️ Duration:</Text>
            <Text style={styles.detailValue}>{sampleData.days} day(s)</Text>
          </View>
        </View>

        {/* Bikes & Add-ons */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>🚴‍♂️ Your Bikes & Add-ons</Text>
          <View style={styles.productsBox}>
            <Text style={styles.productsText}>{sampleData.bicyclesAndAddOns}</Text>
          </View>
        </View>

        {/* Cost Summary */}
        <View style={styles.costBox}>
          <View style={styles.costRow}>
            <Text style={styles.costLabel}>Subtotal:</Text>
            <Text style={styles.costValue}>${sampleData.subtotal}</Text>
          </View>
          <View style={styles.costRow}>
            <Text style={styles.costLabel}>Tax:</Text>
            <Text style={styles.costValue}>${sampleData.tax}</Text>
          </View>
          <View style={[styles.costRow, styles.costRowTotal]}>
            <Text style={styles.costLabelTotal}>💰 Total Paid:</Text>
            <Text style={styles.costValueTotal}>${sampleData.totalCost}</Text>
          </View>
        </View>

        {/* Security PIN */}
        <View style={styles.pinBox}>
          <Text style={styles.pinLabel}>🔐 Your Booking PIN:</Text>
          <Text style={styles.pinValue}>{sampleData.securityPin}</Text>
          <Text style={styles.pinHint}>Keep this PIN secure - you'll need it to manage your booking online</Text>
        </View>

        {/* Custom Instructions / Custom Message */}
        {(customInstructions || (templateType === "stripeReceipt" && customInstructions)) && (
          <View style={styles.section}>
            <Text style={styles.instructionsText}>
              {templateType === "stripeReceipt" ? customInstructions : customInstructions}
            </Text>
          </View>
        )}

        {/* Stripe Receipt Link (for stripeReceipt template) */}
        {templateType === "stripeReceipt" && stripeReceiptLink && (
          <View style={styles.section}>
            <View style={styles.buttonContainer}>
              <View style={styles.button}>
                <Text style={styles.buttonText}>
                  View Stripe Receipt
                </Text>
              </View>
            </View>
            {paymentAmount && (
              <Text style={styles.instructionsText}>
                Payment Amount: {paymentAmount}
              </Text>
            )}
          </View>
        )}

        {/* Manage Booking Button */}
        <View style={styles.buttonContainer}>
          <View style={styles.button}>
            <Text style={styles.buttonText}>
              {buttonText || "✏️ Manage Your Booking"}
            </Text>
          </View>
          {templateType !== "stripeReceipt" && (
            <Text style={styles.buttonSubtext}>
              View, edit, add items, or cancel your booking anytime
            </Text>
          )}
          {templateType === "stripeReceipt" && (
            <Text style={styles.buttonSubtext}>
              View your booking details and PIN
            </Text>
          )}
        </View>

        {/* Security PIN (for stripeReceipt template) */}
        {templateType === "stripeReceipt" && (
          <View style={styles.pinBox}>
            <Text style={styles.pinLabel}>🔐 Your Booking PIN:</Text>
            <Text style={styles.pinValue}>{sampleData.securityPin}</Text>
            <Text style={styles.pinHint}>Keep this PIN secure - you'll need it to manage your booking online</Text>
          </View>
        )}

        {/* Contact Info */}
        <View style={styles.contactBox}>
          <Text style={styles.contactTitle}>📞 Questions or Need Help?</Text>
          <Text style={styles.contactText}>
            📱 Phone: {sampleData.storePhone}
          </Text>
          <Text style={styles.contactText}>
            📧 Email: {sampleData.storeEmail}
          </Text>
          <View style={styles.websiteButton}>
            <Text style={styles.websiteButtonText}>🌐 Visit BonitaBikes.com</Text>
          </View>
        </View>

        {/* Footer Message */}
        {footerMessage && (
          <View style={styles.section}>
            <Text style={styles.footerMessageText}>{footerMessage}</Text>
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            © 2024 {storeName}. All rights reserved.{"\n"}
            This booking confirmation was sent to {sampleData.customerName.toLowerCase()}@example.com
          </Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6F6",
  },
  emailContainer: {
    maxWidth: 600,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(15, 26, 25, 0.07), 0 6px 16px rgba(15, 26, 25, 0.08)",
    elevation: 3,
    marginVertical: 10,
  },
  header: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    backgroundColor: "#0E7C6B",
    padding: 30,
    alignItems: "center",
  },
  logoContainer: {
    marginBottom: 15,
  },
  logoPlaceholder: {
    fontSize: 24,
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#ffffff",
    textAlign: "center",
  },
  headerSubtitle: {
    fontSize: 14,
    color: "#ffffff",
    textAlign: "center",
    marginTop: 8,
    opacity: 0.95,
  },
  section: {
    padding: 20,
  },
  greeting: {
    fontSize: 15,
    color: "#2E3A38",
    marginBottom: 12,
  },
  bold: {
    fontWeight: "bold",
  },
  greetingText: {
    fontSize: 15,
    color: "#2E3A38",
    lineHeight: 22,
  },
  detailsBox: {
    margin: 20,
    backgroundColor: "#F4F6F6",
    borderRadius: 6,
    borderLeftWidth: 4,
    borderLeftColor: "#0E7C6B",
    padding: 15,
  },
  detailsTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#0E7C6B",
    marginBottom: 12,
  },
  detailRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6,
  },
  detailLabel: {
    fontSize: 13,
    color: "#5C6B68",
  },
  detailValue: {
    fontSize: 13,
    color: "#2E3A38",
    fontWeight: "600",
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2E3A38",
    marginBottom: 12,
  },
  productsBox: {
    backgroundColor: "#F4F6F6",
    borderRadius: 6,
    padding: 15,
  },
  productsText: {
    fontSize: 13,
    color: "#2E3A38",
    lineHeight: 20,
  },
  costBox: {
    margin: 20,
    backgroundColor: "#E4F4EC",
    borderRadius: 6,
    borderLeftWidth: 4,
    borderLeftColor: "#1F8A5B",
    padding: 15,
  },
  costRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 6,
  },
  costLabel: {
    fontSize: 15,
    color: "#2E3A38",
  },
  costValue: {
    fontSize: 15,
    color: "#2E3A38",
  },
  costRowTotal: {
    borderTopWidth: 2,
    borderTopColor: "#1F8A5B",
    paddingTop: 12,
    marginTop: 6,
  },
  costLabelTotal: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#2E3A38",
  },
  costValueTotal: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#1F8A5B",
  },
  pinBox: {
    margin: 20,
    backgroundColor: "#E3F2EF",
    borderRadius: 6,
    borderWidth: 3,
    borderColor: "#0E7C6B",
    padding: 20,
    alignItems: "center",
  },
  pinLabel: {
    fontSize: 13,
    color: "#5C6B68",
    marginBottom: 8,
  },
  pinValue: {
    fontSize: 32,
    fontWeight: "bold",
    color: "#0E7C6B",
    letterSpacing: 8,
  },
  pinHint: {
    fontSize: 11,
    color: "#5C6B68",
    marginTop: 10,
    textAlign: "center",
  },
  instructionsText: {
    fontSize: 14,
    color: "#2E3A38",
    lineHeight: 20,
    backgroundColor: "#FDF3E3",
    padding: 15,
    borderRadius: 6,
    borderLeftWidth: 4,
    borderLeftColor: "#B4761B",
  },
  buttonContainer: {
    padding: 20,
    alignItems: "center",
  },
  button: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    backgroundColor: "#0E7C6B",
    paddingVertical: 15,
    paddingHorizontal: 40,
    borderRadius: 16,
    boxShadow: "0 4px 12px rgba(15, 26, 25, 0.1), 0 28px 64px rgba(15, 26, 25, 0.18)",
    elevation: 5,
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 15,
    fontWeight: "bold",
  },
  buttonSubtext: {
    fontSize: 12,
    color: "#5C6B68",
    marginTop: 12,
    textAlign: "center",
  },
  contactBox: {
    margin: 20,
    padding: 20,
    backgroundColor: "#F4F6F6",
    borderRadius: 6,
    alignItems: "center",
    borderTopWidth: 1,
    borderTopColor: "#DDE3E2",
  },
  contactTitle: {
    fontSize: 15,
    fontWeight: "600",
    color: "#2E3A38",
    marginBottom: 12,
  },
  contactText: {
    fontSize: 13,
    color: "#5C6B68",
    marginBottom: 6,
  },
  websiteButton: {
    marginTop: 15,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 2,
    borderColor: "#0E7C6B",
    borderRadius: 6,
  },
  websiteButtonText: {
    color: "#0E7C6B",
    fontSize: 13,
    fontWeight: "600",
  },
  footerMessageText: {
    fontSize: 14,
    color: "#2E3A38",
    textAlign: "center",
    fontStyle: "italic",
  },
  footer: {
    backgroundColor: "#F4F6F6",
    padding: 20,
    alignItems: "center",
  },
  footerText: {
    fontSize: 11,
    color: "#8A9794",
    textAlign: "center",
    lineHeight: 16,
  },
});

export default EmailPreview;

